var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCameraIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 23,
  fill: "none",
  viewBox: "0 0 24 23",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3250FF",
  d: "M18.864 3.82H5.544A4.763 4.763 0 0 0 .789 8.575v5.709a4.763 4.763 0 0 0 4.757 4.757h13.32a4.76 4.76 0 0 0 4.756-4.757V8.576a4.763 4.763 0 0 0-4.757-4.757M4.594 16.187a.952.952 0 1 1 0-1.904.952.952 0 0 1 0 1.903m0-7.612a.951.951 0 1 1 0-1.902.951.951 0 0 1 0 1.902m7.61 6.66a3.806 3.806 0 1 1 0-7.612 3.806 3.806 0 0 1 0 7.612m7.612.951a.952.952 0 1 1 0-1.903.952.952 0 0 1 0 1.903m0-7.61a.952.952 0 1 1 0-1.904.952.952 0 0 1 0 1.903m-5.709 2.854a1.903 1.903 0 1 1-3.805 0 1.903 1.903 0 0 1 3.805 0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.788.014h22.834v22.834H.788z"
})))));
export { SvgCameraIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/camera-icon.svg";